"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewScrollLeft = exports.onScroll = void 0;
var onScroll = function (_a) {
    var wrapperOffsetWidth = _a.wrapperOffsetWidth, tabsOffsetWidth = _a.tabsOffsetWidth, wrapperScrollLeft = _a.wrapperScrollLeft, setNextShow = _a.setNextShow, setPrevShow = _a.setPrevShow;
    // show next button if tabs width more then wrapper
    if (wrapperScrollLeft + wrapperOffsetWidth < tabsOffsetWidth) {
        setNextShow(true);
    }
    else {
        setNextShow(false);
    }
    // show prev button if tabs container have offset on left
    if (wrapperScrollLeft > 0) {
        setPrevShow(true);
    }
    else {
        setPrevShow(false);
    }
};
exports.onScroll = onScroll;
var getNewScrollLeft = function (_a) {
    var wrapperWidth = _a.wrapperWidth, buttonsWidthArray = _a.buttonsWidthArray, gapBetweenBtns = _a.gapBetweenBtns, wrapperScrollLeft = _a.wrapperScrollLeft, direction = _a.direction;
    var newScrollLeft = 0;
    // border adjustment for small screens
    var borderAdjustment = (gapBetweenBtns === 0) ? 2 : 0;
    // calculate scroll left
    if (direction === 'next') {
        if (buttonsWidthArray.length) {
            for (var _i = 0, buttonsWidthArray_1 = buttonsWidthArray; _i < buttonsWidthArray_1.length; _i++) {
                var currentBtnWidth = buttonsWidthArray_1[_i];
                var btnWidth = currentBtnWidth + gapBetweenBtns;
                if (newScrollLeft + btnWidth < wrapperWidth + wrapperScrollLeft) {
                    newScrollLeft += btnWidth;
                }
                else {
                    break;
                }
            }
        }
    }
    if (direction === 'prev') {
        if (buttonsWidthArray.length && wrapperScrollLeft > wrapperWidth) {
            for (var _b = 0, buttonsWidthArray_2 = buttonsWidthArray; _b < buttonsWidthArray_2.length; _b++) {
                var currentBtnWidth = buttonsWidthArray_2[_b];
                var btnWidth = currentBtnWidth + gapBetweenBtns;
                newScrollLeft += btnWidth;
                if (newScrollLeft > wrapperScrollLeft - wrapperWidth) {
                    break;
                }
            }
        }
    }
    if (newScrollLeft > borderAdjustment) {
        return newScrollLeft + borderAdjustment;
    }
    return newScrollLeft;
};
exports.getNewScrollLeft = getNewScrollLeft;
